var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.746,
    height: 81.771,
    viewBox: "0 0 180.746 81.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(-628 -215.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SLOGAN",
    transform: "translate(630.599 283.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_714",
    "data-name": "Trazado 714",
    d: "M643.627,477.013h-4.248l-.815,2.218h-.989l3.406-9.218h1.055l3.393,9.218h-.989Zm-2.124-5.825-1.844,5.05h3.687Z",
    transform: "translate(-637.575 -469.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_715",
    "data-name": "Trazado 715",
    d: "M675.849,476.708a3.765,3.765,0,0,1,0,7.508,3.117,3.117,0,0,1-2.9-1.71v5.05h-.922V476.815h.922v1.6A3.094,3.094,0,0,1,675.849,476.708Zm-.187.815a2.949,2.949,0,0,0,0,5.878,2.693,2.693,0,0,0,2.712-2.953A2.663,2.663,0,0,0,675.662,477.523Z",
    transform: "translate(-662.678 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_716",
    "data-name": "Trazado 716",
    d: "M709.07,476.708a3.765,3.765,0,0,1,0,7.508,3.116,3.116,0,0,1-2.9-1.71v5.05h-.922V476.815h.922v1.6A3.094,3.094,0,0,1,709.07,476.708Zm-.187.815a2.949,2.949,0,0,0,0,5.878,2.693,2.693,0,0,0,2.712-2.953A2.663,2.663,0,0,0,708.883,477.523Z",
    transform: "translate(-686.883 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_717",
    "data-name": "Trazado 717",
    d: "M753.88,470.037a3.171,3.171,0,0,1,2.872,1.683v-4.168h.935v9.886h-.935v-1.63a3.042,3.042,0,0,1-2.886,1.737,3.764,3.764,0,0,1,.013-7.508Zm.16.815a2.663,2.663,0,0,0-2.712,2.926,2.72,2.72,0,1,0,2.712-2.926Z",
    transform: "translate(-719.766 -467.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_718",
    "data-name": "Trazado 718",
    d: "M787.182,484.216a3.758,3.758,0,0,1,0-7.508,3.279,3.279,0,0,1,3.447,3.38,6.447,6.447,0,0,1-.026.735H784.55a2.55,2.55,0,0,0,2.632,2.605,2.258,2.258,0,0,0,2.351-1.63h.989A3.207,3.207,0,0,1,787.182,484.216Zm-2.632-4.155h5.13a2.386,2.386,0,0,0-2.539-2.551A2.518,2.518,0,0,0,784.55,480.061Z",
    transform: "translate(-743.972 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_719",
    "data-name": "Trazado 719",
    d: "M833.1,476.708a3.765,3.765,0,0,1,0,7.508,3.116,3.116,0,0,1-2.9-1.71v5.05h-.922V476.815h.922v1.6A3.094,3.094,0,0,1,833.1,476.708Zm-.187.815a2.949,2.949,0,0,0,0,5.878,2.693,2.693,0,0,0,2.712-2.953A2.663,2.663,0,0,0,832.909,477.523Z",
    transform: "translate(-777.249 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_720",
    "data-name": "Trazado 720",
    d: "M868.636,484.4H867.7v-1.283a2.635,2.635,0,0,1-2.485,1.4,2.831,2.831,0,0,1-2.966-3.153V477.1h.922v4.155a2.134,2.134,0,0,0,2.218,2.445c1.363,0,2.311-.855,2.311-2.632V477.1h.935Z",
    transform: "translate(-801.276 -474.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_721",
    "data-name": "Trazado 721",
    d: "M899.116,479.869a2.134,2.134,0,0,0-2.218-2.445c-1.362,0-2.311.855-2.311,2.632v3.981h-.935v-7.294h.935v1.242a2.665,2.665,0,0,1,2.485-1.376,2.831,2.831,0,0,1,2.966,3.153v4.275h-.922Z",
    transform: "translate(-824.155 -474.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_722",
    "data-name": "Trazado 722",
    d: "M923.065,472.976H922.05v-.788h1.015v-1.83h.949v1.83h2v.788h-2v4.529c0,.9.307,1.176,1.149,1.176h.855v.8h-1c-1.269,0-1.95-.521-1.95-1.977Z",
    transform: "translate(-844.846 -469.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_723",
    "data-name": "Trazado 723",
    d: "M944.372,484.216a3.755,3.755,0,1,1,3.674-3.754A3.556,3.556,0,0,1,944.372,484.216Zm0-.815a2.952,2.952,0,1,0-2.672-2.939A2.643,2.643,0,0,0,944.372,483.4Z",
    transform: "translate(-858.473 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_724",
    "data-name": "Trazado 724",
    d: "M975.289,484.216c-1.657,0-2.819-.828-2.939-2.164h.962c.08.8.775,1.376,1.963,1.376,1.042,0,1.63-.561,1.63-1.256,0-1.8-4.382-.748-4.382-3.487,0-1.082,1.029-1.977,2.565-1.977a2.369,2.369,0,0,1,2.672,2.231h-.935a1.558,1.558,0,0,0-1.764-1.429c-.975,0-1.59.521-1.59,1.162,0,1.977,4.315.922,4.355,3.5C977.827,483.348,976.8,484.216,975.289,484.216Z",
    transform: "translate(-881.495 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_725",
    "data-name": "Trazado 725",
    d: "M1015.23,477.1h.962l-4.328,10.727h-.975l1.416-3.473-2.992-7.254h1.029l2.485,6.225Z",
    transform: "translate(-908.426 -474.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_726",
    "data-name": "Trazado 726",
    d: "M1054.784,476.708a3.148,3.148,0,0,1,3.353,2.485h-1a2.222,2.222,0,0,0-2.351-1.683c-1.43,0-2.592.975-2.592,2.952s1.162,2.966,2.592,2.966a2.216,2.216,0,0,0,2.351-1.7h1a3.2,3.2,0,0,1-3.353,2.485,3.76,3.76,0,0,1,0-7.508Z",
    transform: "translate(-938.978 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_727",
    "data-name": "Trazado 727",
    d: "M1089.129,484.4h-.935v-1.283a2.636,2.636,0,0,1-2.484,1.4,2.831,2.831,0,0,1-2.966-3.153V477.1h.922v4.155a2.134,2.134,0,0,0,2.218,2.445c1.362,0,2.311-.855,2.311-2.632V477.1h.935Z",
    transform: "translate(-961.929 -474.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_728",
    "data-name": "Trazado 728",
    d: "M1117.966,476.708a3.765,3.765,0,0,1,0,7.508,3.116,3.116,0,0,1-2.9-1.71v5.05h-.922V476.815h.922v1.6A3.094,3.094,0,0,1,1117.966,476.708Zm-.187.815a2.949,2.949,0,0,0,0,5.878,2.693,2.693,0,0,0,2.712-2.953A2.663,2.663,0,0,0,1117.779,477.523Z",
    transform: "translate(-984.808 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_729",
    "data-name": "Trazado 729",
    d: "M1149.412,484.216a3.755,3.755,0,1,1,3.674-3.754A3.556,3.556,0,0,1,1149.412,484.216Zm0-.815a2.952,2.952,0,1,0-2.672-2.939A2.643,2.643,0,0,0,1149.412,483.4Z",
    transform: "translate(-1007.866 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_730",
    "data-name": "Trazado 730",
    d: "M1184.429,479.869a2.134,2.134,0,0,0-2.218-2.445c-1.363,0-2.311.855-2.311,2.632v3.981h-.935v-7.294h.935v1.242a2.666,2.666,0,0,1,2.485-1.376,2.831,2.831,0,0,1,2.966,3.153v4.275h-.921Z",
    transform: "translate(-1032.037 -474.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_731",
    "data-name": "Trazado 731",
    d: "M1212.123,484.216a3.758,3.758,0,0,1,0-7.508,3.279,3.279,0,0,1,3.447,3.38,6.389,6.389,0,0,1-.027.735h-6.052a2.551,2.551,0,0,0,2.632,2.605,2.258,2.258,0,0,0,2.351-1.63h.989A3.207,3.207,0,0,1,1212.123,484.216Zm-2.632-4.155h5.13a2.385,2.385,0,0,0-2.538-2.551A2.519,2.519,0,0,0,1209.491,480.061Z",
    transform: "translate(-1053.587 -474.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_732",
    "data-name": "Trazado 732",
    d: "M1242.1,484.216c-1.656,0-2.819-.828-2.939-2.164h.962c.08.8.775,1.376,1.964,1.376,1.042,0,1.63-.561,1.63-1.256,0-1.8-4.382-.748-4.382-3.487,0-1.082,1.028-1.977,2.565-1.977a2.369,2.369,0,0,1,2.672,2.231h-.935a1.558,1.558,0,0,0-1.763-1.429c-.975,0-1.59.521-1.59,1.162,0,1.977,4.315.922,4.355,3.5C1244.633,483.348,1243.6,484.216,1242.1,484.216Z",
    transform: "translate(-1075.893 -474.223)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LOGO-2",
    "data-name": "LOGO",
    transform: "translate(628 215.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_-_Capas",
    "data-name": "Logo - Capas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BEE",
    transform: "translate(79.513 12.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_733",
    "data-name": "Trazado 733",
    d: "M949.053,295.271c0,11.48-5.32,16.869-14.349,16.869-7.98,0-13.72-4.549-13.72-13.79V263.681a2.265,2.265,0,0,1,1.967-2.275,2.219,2.219,0,0,1,2.512,2.225v19.389a11.864,11.864,0,0,1,9.52-4.55C944.013,278.471,949.053,283.791,949.053,295.271Zm-23.589,3.079c0,6.65,3.85,9.73,9.24,9.73,6.44,0,9.869-4.06,9.869-12.81,0-8.61-3.5-12.74-9.869-12.74-6.58,0-9.24,6.16-9.24,6.16Z",
    transform: "translate(-920.984 -261.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_734",
    "data-name": "Trazado 734",
    d: "M1056.87,324.325c11.2,0,13.37,8.89,13.37,13.65,0,2.03,0,4.48-2.8,4.48H1047c0,6.93,3.99,11.41,10.57,11.41a12.891,12.891,0,0,0,8.4-3.01,1.958,1.958,0,0,1,1.149-.418,2.07,2.07,0,0,1,2.142,2.025,2.1,2.1,0,0,1-.771,1.613c-1.049,1.05-4.689,3.92-10.919,3.92-9.31,0-15.12-5.11-15.12-16.869C1042.451,330.344,1047.771,324.325,1056.87,324.325Zm0,4.06c-6.089,0-9.449,3.92-9.869,10.15h18.829C1065.83,333.495,1064.081,328.385,1056.87,328.385Z",
    transform: "translate(-1009.486 -307.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_735",
    "data-name": "Trazado 735",
    d: "M1177.048,324.325c11.2,0,13.37,8.89,13.37,13.65,0,2.03,0,4.48-2.8,4.48h-20.439c0,6.93,3.99,11.41,10.569,11.41a12.889,12.889,0,0,0,8.4-3.01,1.96,1.96,0,0,1,1.149-.418,2.07,2.07,0,0,1,2.141,2.025,2.1,2.1,0,0,1-.771,1.613c-1.049,1.05-4.689,3.92-10.919,3.92-9.31,0-15.12-5.11-15.12-16.869C1162.628,330.344,1167.948,324.325,1177.048,324.325Zm0,4.06c-6.089,0-9.45,3.92-9.869,10.15h18.829C1186.007,333.495,1184.258,328.385,1177.048,328.385Z",
    transform: "translate(-1097.048 -307.245)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ISOTIPO",
    d: "M699.523,243.416c-2.392-4.545-9.609-5.987-16.43-3.285a18.492,18.492,0,0,0-2.342,1.126,23.682,23.682,0,0,0,1.694-4.546c2.409-9.27-.948-18.62-7.484-20.844a9.684,9.684,0,0,0-7.872.816c-3.93,2.12-7.117,6.629-8.523,12.061a23.976,23.976,0,0,0-.722,7.853,13.343,13.343,0,0,0-4.268-5.027,13.56,13.56,0,0,0-7.882-2.452A17.671,17.671,0,0,0,631.48,236.9c-5.438,7.7-4.387,17.837,2.346,22.608a13.563,13.563,0,0,0,7.876,2.447h0a15.553,15.553,0,0,0,1.614-.093,23.465,23.465,0,0,0,6.134,9.568l0,.012.411.372c.373.342.76.672,1.156.994.112.091.223.181.336.269q.48.377.979.735l.044.035.668.612.1-.089a25.362,25.362,0,0,0,5.524,2.748l-.016.035,1.174.35c.108.032.217.058.325.089l.007,0a23.89,23.89,0,0,0,3.844.755l.524.058.019-.02q.894.073,1.777.074a17.687,17.687,0,0,0,12.355-4.635,13.629,13.629,0,0,1,5.332,1.66A11.745,11.745,0,0,1,680.995,271a16.643,16.643,0,0,0,1.882-13.128,16.14,16.14,0,0,0,1.746.094,18.941,18.941,0,0,0,6.878-1.334c4.026-1.595,7.12-4.4,8.277-7.518A6.842,6.842,0,0,0,699.523,243.416ZM667.49,262.351a102.611,102.611,0,0,0-7.914,12.848,23.216,23.216,0,0,1-4.832-2.316,97.082,97.082,0,0,0,10.108-12.391,97.615,97.615,0,0,0,8.317-13.669,23.242,23.242,0,0,1,3.793,3.778A103.469,103.469,0,0,0,667.49,262.351Zm-6.876-33.075c1.262-4.874,4.059-8.886,7.481-10.731a7.618,7.618,0,0,1,6.185-.675c5.51,1.875,8.254,10.088,6.118,18.309a18.45,18.45,0,0,1-5.483,9.333c-.508-.42-1.032-.825-1.576-1.21l-.005,0-.031-.021c-.371-.261-.748-.508-1.129-.748-.1-.061-.193-.12-.29-.18-.442-.271-.89-.529-1.343-.771l-.5-.27-.009.008a23.806,23.806,0,0,0-9.51-2.561A20.876,20.876,0,0,1,660.614,229.276ZM641.7,259.836a11.463,11.463,0,0,1-6.655-2.059c-5.78-4.1-6.605-12.916-1.839-19.66a15.767,15.767,0,0,1,12.487-6.885,11.456,11.456,0,0,1,6.66,2.064c5.784,4.089,6.609,12.907,1.84,19.655A15.791,15.791,0,0,1,641.7,259.836Zm3.727,1.657a18.844,18.844,0,0,0,13.893-19.65,21.3,21.3,0,0,1,9.06,2.026,117.242,117.242,0,0,0-18.018,25.486A21.251,21.251,0,0,1,645.428,261.493Zm33.434,8.891c-2.779,3.929-7.406,5.947-12.467,5.964a128.332,128.332,0,0,0,13.92-19.686c.147.423.284.849.4,1.28A14.559,14.559,0,0,1,678.863,270.384Zm18.932-22.01c-.952,2.56-3.6,4.91-7.073,6.287a15.867,15.867,0,0,1-8.53.96c-.173-.471-.365-.936-.571-1.4l.012-.023-.228-.474a23.563,23.563,0,0,0-2.036-3.437c-.033-.046-.063-.093-.1-.139-.019-.027-.037-.055-.057-.082l-.722-.992-.027.026q-.626-.775-1.32-1.506a12.754,12.754,0,0,1,6.724-5.5c5.636-2.233,11.946-1.178,13.777,2.3A4.783,4.783,0,0,1,697.8,248.374Z",
    transform: "translate(-628 -215.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "C",
    transform: "translate(173.86 22.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8",
    transform: "translate(1.874 1.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_736",
    "data-name": "Trazado 736",
    d: "M1277.277,301.714a1.6,1.6,0,0,1,1.307.585.254.254,0,0,1,.059.161.241.241,0,0,1-.246.246.253.253,0,0,1-.2-.1,1.086,1.086,0,0,0-.916-.4c-.781,0-1.2.5-1.2,1.544,0,1.061.415,1.553,1.2,1.553a1.548,1.548,0,0,0,.984-.365.252.252,0,0,1,.161-.059.246.246,0,0,1,.246.246.263.263,0,0,1-.11.212,1.935,1.935,0,0,1-1.281.458c-1.094,0-1.747-.653-1.747-2.045S1276.183,301.714,1277.277,301.714Z",
    transform: "translate(-1275.53 -301.714)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_737",
    "data-name": "Trazado 737",
    d: "M1272.517,303.4a3.444,3.444,0,1,1,2.966-2.966A3.448,3.448,0,0,1,1272.517,303.4Zm.078-6.478a3.109,3.109,0,1,0,2.537,2.537A3.113,3.113,0,0,0,1272.6,296.924Z",
    transform: "translate(-1268.625 -296.545)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.a74b411895e19cc63cfd347cc0ae49d9.svg";
export { ForwardRef as ReactComponent };